module.exports = __webpack_public_path__ + "static/cleannupp_logo-52e5746cc61ec8d670d882952e03c783.png";